// extracted by mini-css-extract-plugin
module.exports = {"main":"freeworkout-module--main--2B7fD","img":"freeworkout-module--img--2AyX8","form":"freeworkout-module--form--16BK-"};